import errorIcon from "assets/images/error-icon.svg";
import classNames from "classnames";
import React, {useLayoutEffect, useRef, useState} from "react";
import {textInput as strings} from "strings";

import {formatPhoneNumber} from "liberty-core/sharedFunctions";

import styles from "./TextInput.module.css";

type TextInputProps = {
  className?: string;
  placeholder?: string;
  label: string;
  type: "password" | "text" | "tel" | "email";
  disabled?: boolean;
  value: string;
  errorText?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeText?: (value: string) => void;
  onFocus?: () => void;
} & React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export default function TextInput({
  className,
  placeholder,
  label,
  type,
  disabled,
  value,
  errorText,
  onChange,
  onChangeText,
  onFocus,
  ...rest
}: TextInputProps) {
  const errorRef = useRef<HTMLSpanElement>(null);
  const [errorWidth, setErrorWidth] = useState(0);
  useLayoutEffect(() => {
    if (errorRef.current) {
      setErrorWidth(errorRef.current.offsetWidth);
    }
  }, [value, errorText]);
  const [showPassword, setShowPassword] = useState(false);

  let displayValue = value;
  if (type === "tel") {
    displayValue = formatPhoneNumber(value);
  }

  return (
    <div className={classNames(styles.container, className)}>
      <input
        {...rest}
        type={showPassword ? "text" : type}
        disabled={disabled}
        onChange={(event) => {
          if (type === "tel") {
            event.target.value = event.target.value.replace(/\D/g, "");
            if (event.target.value.length > 10) {
              event.target.value = event.target.value.slice(0, 10);
            }
          }
          onChange?.(event);
          onChangeText?.(event.target.value);
        }}
        onFocus={onFocus}
        className={styles.input}
        placeholder={placeholder ?? label}
        style={{paddingRight: errorText ? errorWidth + 18 : 70}}
        value={displayValue}
      />
      {value !== "" ? <label className={styles.label}>{label}</label> : null}
      {errorText && (
        <span
          onLoad={() => {
            if (errorRef.current) {
              setErrorWidth(errorRef.current.offsetWidth);
            }
          }}
          ref={errorRef}
          className={styles.errorTextContainer}
        >
          <span className={styles.errorText}>{errorText}</span>
          <img alt="" src={errorIcon} />
        </span>
      )}
      {type === "password" && !errorText ? (
        <button
          className={styles.showButton}
          type="button"
          onClick={() => {
            setShowPassword((prev) => !prev);
          }}
        >
          {showPassword ? strings.hide : strings.show}
        </button>
      ) : null}
    </div>
  );
}
